/* eslint-disable */
import * as Types from '../graphql/types.generated';

import { gql } from '@apollo/client';
export type ReviewAggregationCollectionFragment = { __typename?: 'ReviewCollection', total: number, items: Array<{ __typename?: 'Review', starRating?: number | null, sys: { __typename?: 'Sys', id: string } } | null> };

export const ReviewAggregationCollectionFragmentDoc = gql`
    fragment ReviewAggregationCollection on ReviewCollection {
  items {
    sys {
      id
    }
    starRating
  }
  total
}
    `;